import { createTheme } from '@mui/material'

export const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#c9a227',
      light: '#e0bc4a',
      dark: '#8f7018'
    },
    secondary: {
      main: '#8b7355',
      light: '#a89072',
      dark: '#5c4a38'
    },
    background: {
      default: '#0f0e0c',
      paper: '#1a1814'
    },
    text: {
      primary: '#f5f0e8',
      secondary: '#a39a8c'
    },
    divider: 'rgba(255, 255, 255, 0.08)'
  },
  typography: {
    fontFamily: '"Source Sans 3", "Helvetica Neue", Arial, sans-serif',
    h1: {
      fontFamily: '"Fraunces", Georgia, serif',
      fontWeight: 500,
      letterSpacing: '0.01em'
    },
    h2: {
      fontFamily: '"Fraunces", Georgia, serif',
      fontWeight: 500
    },
    h3: {
      fontFamily: '"Fraunces", Georgia, serif',
      fontWeight: 500
    },
    h4: {
      fontFamily: '"Fraunces", Georgia, serif',
      fontWeight: 500
    },
    h5: {
      fontFamily: '"Fraunces", Georgia, serif',
      fontWeight: 500
    },
    h6: {
      fontFamily: '"Fraunces", Georgia, serif',
      fontWeight: 500
    },
    body1: {
      lineHeight: 1.75
    }
  },
  shape: {
    borderRadius: 10
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 500,
          letterSpacing: '0.04em'
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        }
      }
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none'
        }
      }
    }
  }
})
